export default "/images/stickies.svg?a09a5f6f1f7b83be3b7fa29354c82e63";